exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tag-color[data-v-3fcb8b22] {\n  width: 10px;\n  height: 10px;\n  border-radius: 5px;\n  display: inline-block;\n  margin-right: 0.8rem;\n}\n.tag-name[data-v-3fcb8b22] {\n  color: #bec0ca;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3fcb8b22","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/salesDashboard/subcomponents/cards/BooksTags.vue
// module id = sx5l
// module chunks = 0